<template>
  <section class="container section pt-0">
    <conversation-datatable />
  </section>
</template>

<script>
import ConversationDatatable from "./conversation_datatable/Index.vue";

export default {
  name: "Conversations",
  components: { ConversationDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
